import once from 'hs-lodash/once';
export const initPrimaryTabUtil = () => {
  let _isPrimary = false;
  return {
    setIsPrimary: isPrimary => {
      _isPrimary = isPrimary;
    },
    get isPrimary() {
      return _isPrimary;
    }
  };
};

/**
 * Get the singleton instance of the primary tab util, initialized on first call
 */
export const getPrimaryTabUtil = once(initPrimaryTabUtil);